import { zodResolver } from '@portals-platform/ui-forms';
import type { RefObject } from 'react';
import type { Resolver } from 'react-hook-form';
import type { CertificateTemplateResponse } from '../../data-access/api/responses.js';
import { getDynamicFieldKeysForTemplate } from './dynamic-fields.js';
import { getSchema } from './schema.js';
import type { FormValues } from './types.js';

const DEFAULT_MESSAGES = {
  requiredMessage: 'This field is required',
  invalidYearMessage: 'Enter a four-digit year',
  invalidAmountMessage: 'Enter a valid amount',
};

export function getResolver({
  templatesRef,
  messages = DEFAULT_MESSAGES,
}: {
  templatesRef: RefObject<CertificateTemplateResponse[]>;
  messages?: typeof DEFAULT_MESSAGES;
}): Resolver<FormValues> {
  return (values, context, options) => {
    const template =
      templatesRef.current.find((candidate) => candidate.id === values.certificateTemplateId) ??
      null;

    const schema = getSchema({
      ...messages,
      dynamicFieldKeys: getDynamicFieldKeysForTemplate(template),
    });

    return zodResolver(schema)(values, context, options);
  };
}
